import 'bootstrap-sass/assets/javascripts/bootstrap/tab';
import 'bootstrap-sass/assets/javascripts/bootstrap/collapse';
import Component from '../site/Component';

/**
 * Component for tabbed content
 */
export default class Tabs extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    // Elements
    this.panelsInGroup =
      this.element.querySelectorAll(this.elements.togglePanel);
    this.toggleContent = this.element
      .querySelector(this.elements.toggleContent);
    this.makeTabs = this.makeTabs.bind(this);
    this.initialize = this.initialize.bind(this);
    this.moduleName = this.element.dataset.moduleName;

    // Can be 'tabs', 'accordion', or 'both'
    this.toggleable = this.element.dataset.toggleView;

    // Inits
    if ('both' === this.toggleable) {
      this.toggleBreakpoint =
        this.utils.breakpoints.generateMedia('m', false);
      this.initialize(this.toggleBreakpoint);
      this.toggleBreakpoint.addListener(this.initialize);
    } else if ('tabs' === this.toggleable || 'collapse' === this.toggleable) {
      // Add tabs or accordion based on value of data-toggle-view
      this.toggleBreakpoint = {
        matches: 'tabs' === this.toggleable,
      };
      this.initialize(this.toggleBreakpoint);
    }
  }

  /**
   * Activate first tab and associated content
   */
  initialize(query) {
    if (query.matches) {
      this.initializeTabs();
    } else {
      this.initializeAccordion();
    }

    // re-initialize carousels within the tabbed markup
    this.manifest.manager.reinitComponent('carousel', this.element);
  }

  /**
   * Create tabs markup and activate tab functionality
   */
  initializeTabs() {
    this.makeTabs();

    Array.prototype.forEach.call(this.tabToggles, (toggle, idx) => {
      // Show first tab
      if (0 === idx) {
        this.activateTab(idx);
      }

      // Add event listeners
      toggle.addEventListener('click', () => {
        this.activateTab(idx);
      });
    });
  }

  /**
   * Create accordion markup and activate panel functionality
   */
  initializeAccordion() {
    this.makeAccordian();

    Array.prototype.forEach.call(this.accordionPanels, (panel, idx) => {
      // Show first panel
      if (0 === idx) {
        this.activatePanel(idx);
      }

      // Add event listeners
      this.accordionToggles.item(idx).addEventListener('click', () => {
        this.togglePanel(idx);

        Array.prototype.forEach
          .call(this.accordionPanels, (closePanel, closeIndex) => {
            if (closePanel !== panel) {
              this.deactivatePanel(closeIndex);
            }
          });

        setTimeout(() => {
          const top = this.accordionHeadings.item(idx).offsetTop;
          window.scrollTo(0, top);
        }, 500);
      });
    });
  }

  /**
  * Activate a specific tab
  *
  * @param {num} index - Index of tab you want to activate
  */
  activateTab(index) {
    $(this.tabToggles.item(index)).tab('show');
  }

  /**
  * TogglePanel
  *
  * @param {num} index - Index of panel you want to activate
  */
  togglePanel(index) {
    this.accordionHeadings.item(index)
      .classList.toggle(this.options.accordionActive);
    $(this.accordionPanels.item(index)).collapse('toggle');
  }

  /**
  * Activate a specific accordion panel
  *
  * @param {num} index - Index of panel you want to activate
  */
  activatePanel(index) {
    this.accordionHeadings.item(index)
      .classList.add(this.options.accordionActive);
    $(this.accordionPanels.item(index)).collapse('show');
  }

  /**
  * Deactivate a specific accordion panel
  *
  * @param {num} index - Index of panel you want to deactivate
  */
  deactivatePanel(index) {
    this.accordionHeadings.item(index)
      .classList.remove(this.options.accordionActive);
    $(this.accordionPanels.item(index)).collapse('hide');
  }

  /**
  * wrap panels in tabs on desktop
  */
  makeTabs() {
    /* eslint-disable arrow-body-style, max-len */
    this.toggleContent.innerHTML = `
<ul class="nav nav-tabs" role="tablist">
  ${Array.prototype.map.call(this.panelsInGroup, (panel) => {
    return `<li role="presentation" class="tablist__item tabbed-content__header">
      <a href="#${this.moduleName}-${panel.dataset.slug}"
        aria-controls="${panel.dataset.slug}"
        role="tab"
        data-type="link-event" data-category="Title Tab"
        data-action="Toggle Tab" data-label="${panel.dataset.title}"
        data-toggle="tab">${panel.dataset.title}
      </a>
    </li>`;
  }).join('')}
</ul>
<div class="tab-content ${this.moduleName}__content">
  ${Array.prototype.map.call(this.panelsInGroup, (panel) => {
    return `<div role="tabpanel" class="tab-pane" id="${this.moduleName}-${panel.dataset.slug}">
      ${panel.outerHTML}
    </div>`;
  }).join('')}
</div>
`;

    // Re-init tab nav and tab pane queries
    this.tabToggles = this.element.querySelectorAll(this.elements.tabToggle);
  }

  /**
  * wrap panels in accordian on mobile
  */
  makeAccordian() {
    this.toggleContent.innerHTML = `
<div class="panel-group"
  id="#${this.moduleName}-accordian"
  role="tablist"
  aria-multiselectable="true"
  >
  ${Array.prototype.map.call(this.panelsInGroup, (panel, idx) => {
    return `<div class="panel">
      <div class="panel-heading" role="tab" id="${this.moduleName}-heading-${idx}">
        <h4 class="panel-title">
          <a role="button"
            data-toggle="collapse"
            data-parent="${this.moduleName}-accordion"
            href="#${this.moduleName}-${panel.dataset.slug}-panel"
            aria-expanded="false"
            aria-controls="${panel.dataset.slug}-accordian">${panel.dataset.title}</a>
        </h4>
      </div>
      <div id="${this.moduleName}-${panel.dataset.slug}-panel"
        class="panel-collapse collapse"
        role="tabpanel"
        aria-labelledby="heading-${idx}"
      >
        <div class="panel-body ${this.moduleName}__content">${panel.outerHTML}</div>
      </div>
    </div>`;
  }).join('')}
</div>
    `;
    /* eslint-enable */

    // Re-init accordion pane queries
    this.accordionToggles = this.element
      .querySelectorAll(this.elements.accordionToggle);
    this.accordionPanels = this.element
      .querySelectorAll(this.elements.accordionPanel);
    this.accordionHeadings = this.element
      .querySelectorAll(this.elements.accordionHeading);
  }
}
